import { IAvatarElementV1, ICatalogV1 } from '../models/AndromeTV.types';
import { Backend } from '../Backend';

export class CatalogApi {
  /**
   * Retrieve the list of all avatars
   */
  static avatarList(backend: Backend): Promise<IAvatarElementV1[]> {
    const url = backend.makeUrl('aa/v1/avatar');
    return backend.getJson(url, backend.bearer) as Promise<IAvatarElementV1[]>;
  }

  /**
   * Retrieve the list of catalogs for the users' organization
   */
  static list(backend: Backend): Promise<ICatalogV1[]> {
    const url = backend.makeUrl('aa/v1/catalog');
    return backend.getJson(url, backend.bearer) as Promise<ICatalogV1[]>;
  }
}
